export default __webpack_public_path__ + "5db78473b73bd775f283d3e533a90d26.jpg";